import { useQuery } from '@tanstack/react-query'
import { getAdAccounts } from 'services/api/marketing-api'

const useAdsAccounts = () => {
  return useQuery({
    queryKey: ['ad-accounts'],
    queryFn: getAdAccounts,
    select: (data) => data?.data,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  })
}

export default useAdsAccounts
